/**
 * Multi-step Forminator form (SRO cost quiz on the SRO pages). Rebuilds the step
 * header and footer the Forminator script generated, and submits to /api/leads/submit.
 */
const SUCCESS = 'Спасибо! Заявка отправлена, мы свяжемся с вами в ближайшее время.'
const REQUIRED = 'Это поле обязательно для заполнения'

export function initForminator() {
  document.querySelectorAll<HTMLFormElement>('form.forminator-custom-form').forEach((form) => {
    const pages = Array.from(form.querySelectorAll<HTMLElement>('.forminator-pagination'))
    if (!pages.length) return
    // Forminator printed the form hidden next to a loading placeholder and swapped them once ready.
    document.querySelectorAll(`div[data-form="${form.id}"]`).forEach((placeholder) => placeholder.remove())
    form.style.display = ''
    form.setAttribute('novalidate', 'novalidate')
    const id = form.id.replace('forminator-module-', 'forminator-custom-form-')
    const steps = form.querySelector<HTMLElement>('.forminator-pagination-steps')
    if (steps) {
      steps.innerHTML = pages
        .map(
          (_, i) =>
            `<div class="forminator-break"${i ? ' aria-hidden="true"' : ''}></div><button type="button" role="tab" id="${id}---page-${i}-label" class="forminator-step forminator-step-${i}" aria-selected="false" aria-controls="${id}---page-${i}" data-nav="${i}"><span class="forminator-step-label">Шаг ${i + 1}</span><span class="forminator-step-dot" aria-hidden="true"></span></button>`,
        )
        .join('') + '<div class="forminator-break" aria-hidden="true"></div>'
    }
    const footer = document.createElement('div')
    footer.className = 'forminator-pagination-footer'
    footer.innerHTML =
      '<button type="button" class="forminator-button forminator-button-back">Предыдущий шаг</button><button type="button" class="forminator-button forminator-button-next">Следующий шаг</button>'
    pages.at(-1)!.after(footer)
    const back = footer.querySelector<HTMLButtonElement>('.forminator-button-back')!
    const next = footer.querySelector<HTMLButtonElement>('.forminator-button-next')!
    const submitLabel = form.querySelector('.forminator-pagination-submit')?.textContent?.trim() || 'Отправить'
    const response = form.querySelector<HTMLElement>('.forminator-response-message')
    let current = 0

    const show = (i: number) => {
      current = i
      pages.forEach((p, n) => {
        p.hidden = n !== i
        if (n !== i) p.setAttribute('aria-hidden', 'true')
        else p.removeAttribute('aria-hidden')
      })
      steps?.querySelectorAll('.forminator-step').forEach((s, n) => {
        s.classList.toggle('forminator-current', n === i)
        s.setAttribute('aria-selected', String(n === i))
      })
      back.classList.toggle('forminator-hidden', i === 0)
      footer.style.justifyContent = i === 0 ? 'flex-end' : 'space-between'
      next.textContent = i === pages.length - 1 ? submitLabel : 'Следующий шаг'
    }

    const valid = (page: HTMLElement) => {
      let ok = true
      page.querySelectorAll('.forminator-error-message').forEach((m) => m.remove())
      page.querySelectorAll('.forminator-has_error').forEach((c) => c.classList.remove('forminator-has_error'))
      page.querySelectorAll<HTMLElement>('.forminator-col').forEach((col) => {
        const required = col.querySelector('.forminator-required')
        if (!required) return
        const radios = col.querySelectorAll<HTMLInputElement>('input[type=radio]')
        const text = col.querySelector<HTMLInputElement>('input[type=text], input[type=tel], input[type=email], textarea')
        const filled = radios.length ? Array.from(radios).some((r) => r.checked) : Boolean(text?.value.trim())
        if (!filled) {
          ok = false
          col.classList.add('forminator-has_error')
          const msg = document.createElement('span')
          msg.className = 'forminator-error-message'
          msg.textContent = REQUIRED
          col.querySelector('.forminator-field')?.appendChild(msg)
        }
      })
      return ok
    }

    const submit = async () => {
      const fields: Record<string, string> = {}
      form.querySelectorAll<HTMLInputElement>('input, textarea').forEach((f) => {
        if (!f.name || f.type === 'hidden' || ((f.type === 'radio' || f.type === 'checkbox') && !f.checked)) return
        const label = f.closest('.forminator-field')?.querySelector('.forminator-label')?.textContent?.replace('*', '').trim() || f.name
        fields[label] = f.value
      })
      next.disabled = true
      try {
        const res = await fetch('/api/leads/submit', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            formId: `forminator-${form.id.replace(/\D/g, '')}`,
            formTitle: 'Расчёт стоимости вступления в СРО',
            pageUrl: location.href,
            pageTitle: document.title,
            fields: { ...fields, 'Телефон': fields['Телефон'] ?? '', phone: fields['Телефон'] ?? '' },
          }),
        })
        const body = await res.json().catch(() => ({}))
        if (response) {
          response.className = `forminator-response-message ${res.ok ? 'forminator-success forminator-show' : 'forminator-error forminator-show'}`
          response.textContent = res.ok ? SUCCESS : body.message || 'Не удалось отправить заявку. Попробуйте позже.'
        }
        if (res.ok) {
          form.reset()
          show(0)
          form.dispatchEvent(new CustomEvent('wpcf7mailsent', { bubbles: true }))
        }
      } finally {
        next.disabled = false
      }
    }

    next.addEventListener('click', () => {
      if (!valid(pages[current])) return
      if (current < pages.length - 1) show(current + 1)
      else void submit()
    })
    back.addEventListener('click', () => show(Math.max(0, current - 1)))
    steps?.addEventListener('click', (e) => {
      const btn = (e.target as HTMLElement).closest<HTMLElement>('[data-nav]')
      const to = Number(btn?.dataset.nav)
      if (btn && to < current) show(to)
    })
    form.addEventListener('submit', (e) => {
      e.preventDefault()
      next.click()
    })
    show(0)
  })
}
